import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Template } from '@web-components/settings/settings.model';
import { PageRequest } from '@models/models';
import { PaginationService } from '@services/pagination/pagination.service';

@Component({
	selector: 'template-list',
	template: require('./template-list.html'),
	styles: [require('./template-list.scss')]
})
export class TemplateListComponent implements OnInit {
	@Input() items: Array<Template>;
	@Output() onEdit: EventEmitter<Template> = new EventEmitter();
	@Output() onDuplicate: EventEmitter<Template> = new EventEmitter();
	@Output() onDelete: EventEmitter<Template> = new EventEmitter();

	pageRequest: PageRequest;
	pageNumbers: Array<number> = [];
	totalItems: number;
	private readonly REQUEST_PARAMS: PageRequest = {
		paging: {
			pageNumber: 0,
			pageSize: 5,
			searchToken: null
		},
		sortCriterias: [
			{
				fieldName: 'name',
				sortAscending: true
			}
		],
		search: ''
	};

	constructor(private paginationService: PaginationService) {}

	ngOnInit(): void {
		this.pageRequest = this.REQUEST_PARAMS;
		this.totalItems = this.items.length;
		this.pageNumbers = this.paginationService.calculatePageNumbers(
			this.totalItems,
			this.pageRequest.paging.pageSize
		);
	}

	updateTemplate(data): void {}

	edit(template: Template): void {
		this.onEdit.emit(template);
	}

	duplicate(template: Template): void {
		this.onDuplicate.emit(template);
	}

	deleteItem(template: Template): void {
		this.onDelete.emit(template);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/settings/common/template-list/template-list.ts